import { render, staticRenderFns } from "./UpdateAdditionalMail.vue?vue&type=template&id=1a3e7485&scoped=true"
import script from "./UpdateAdditionalMail.vue?vue&type=script&lang=js"
export * from "./UpdateAdditionalMail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a3e7485",
  null
  
)

export default component.exports